var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { useGlobalContext } from '../../../../global';
var Button = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  width: ", "px;\n  height: ", "px;\n  border: solid 1px ", ";\n  background-color: ", ";\n  \n  color: ", ";\n  font-size: 14px;\n  line-height: 1.43;\n}\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  width: ", "px;\n  height: ", "px;\n  border: solid 1px ", ";\n  background-color: ", ";\n  \n  color: ", ";\n  font-size: 14px;\n  line-height: 1.43;\n}\n"])), function (p) { return p.minWidth; }, function (p) { return p.minHeight; }, function (p) { return p.borderColor; }, function (p) { return p.backgroundColor; }, function (p) { return p.textColor; });
export var SelectableButton = function (props) {
    var children = props.children, minWidth = props.minWidth, minHeight = props.minHeight, selected = props.selected, onClick = props.onClick;
    var convertThemeString = useGlobalContext().convertThemeString;
    var primary = convertThemeString('{{primary}}');
    var p = {
        minWidth: (minWidth !== null && minWidth !== void 0 ? minWidth : 142),
        minHeight: (minHeight !== null && minHeight !== void 0 ? minHeight : 50),
        textColor: selected ? primary : '#73818f',
        borderColor: selected ? primary : '#c8ced3',
        backgroundColor: selected ? '#e9f7f9' : 'white',
    };
    return (React.createElement(Button, __assign({}, p, { onClick: function () { var _a; return (_a = onClick) === null || _a === void 0 ? void 0 : _a(); } }), children));
};
var templateObject_1;
//# sourceMappingURL=SelectableButton.js.map